"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class DataList extends subscribable_1.default {
    constructor(list, total, params, dataService, type, isStatic = false) {
        super(dataService, "");
        this._list = list;
        this.params = params;
        this._total = total;
        this.type = type;
        if (isStatic) {
            this.isListening = true;
        }
    }
    updateList(list, requestId) {
        let wantedList = this._list.find(l => l.id === requestId);
        if (wantedList) {
            wantedList.list = list;
            this.emit('updated', 'list', this._list.map(l => l.list).flat());
        }
    }
    get requestIds() {
        return this._list.map(lI => lI.id).flat();
    }
    get list() {
        return this._list.map(lI => lI.list).flat();
    }
    set list(inList) {
        this._list = [
            {
                id: "",
                list: inList
            }
        ];
    }
    get total() {
        return this._total;
    }
    set total(value) {
        this._total = value;
    }
}
exports.default = DataList;
//# sourceMappingURL=data-list.js.map